import { EntityMetadata } from '../../../types/entities.types';
import { ISDKEvent } from '../../../types/sdk/events.types';

export function trackPageView(metadata: EntityMetadata = {}): void {
    window.NiceJob.send(ISDKEvent.pageview, { metadata });
}
